import { ListRBACAccessAction, ListRBACAccessActionKind } from "./action";
import { Account } from "../../../api/dealer/DealerApi";
import { RBACRolesResponse } from "../../../api/rbac/types";
import { FeatureToggleDetail } from "../../../pages/featureToggles/types";

export type RBACAccessState = {
  userRoleDetails?:
    | PromiseSettledResult<RBACRolesResponse>
    | PromiseRejectedResult;
  featureToggles?:
    | PromiseSettledResult<FeatureToggleDetail[]>
    | PromiseRejectedResult;
  accountDetails?:
    | PromiseSettledResult<{ data: Account[] }>
    | PromiseRejectedResult;
  toggleProcessed: boolean;
  dataLoaded: boolean;
  rbacEnabled: boolean;
  corporateViewEnabled: boolean;
};

export const getInitialState = (
  enableFTRBACIntegration: boolean,
  enableCorporateView: boolean,
  enableFTRBAC: boolean
): RBACAccessState => {
  const rbacEnabled: boolean = enableFTRBAC ? false : enableFTRBACIntegration;
  return {
    toggleProcessed: !enableFTRBAC,
    dataLoaded: !enableFTRBAC,
    rbacEnabled,
    corporateViewEnabled: enableCorporateView && rbacEnabled,
  };
};

export function listRBACAccessContextReducer(
  state: RBACAccessState,
  action: ListRBACAccessAction
): RBACAccessState {
  switch (action.type) {
    case ListRBACAccessActionKind.SET_USER_ROLE_DETAILS:
      return {
        ...state,
        userRoleDetails: action.payload,
      };
    case ListRBACAccessActionKind.SET_FEATURE_TOGGLE_DETAILS:
      return {
        ...state,
        featureToggles: action.payload,
      };
    case ListRBACAccessActionKind.SET_ACCOUNT_DETAILS:
      return {
        ...state,
        accountDetails: action.payload,
      };
    case ListRBACAccessActionKind.SET_DATA_LOADED:
      return {
        ...state,
        dataLoaded: action.payload,
      };
    case ListRBACAccessActionKind.UPDATE_PROCESSED_ACTION: {
      return {
        ...state,
        rbacEnabled: action.payload.rbacEnabled,
        corporateViewEnabled: action.payload.corporateViewEnabled,
        toggleProcessed: action.payload.toggleProcessed,
        dataLoaded: action.payload.dataLoaded ?? state.dataLoaded,
      };
    }
    default:
      return state;
  }
}
